export const baseDashboardImagesPath = document.kvConfig.kioskMode ? './images/dashboard/images/icons/pj-scope-icons/enabled/' : ((location.port === '9007')
  ? 'http://quotesflooring.com/content/Views/dashboard/images/icons/pj-scope-icons/enabled/'
  : '/content/Views/dashboard/images/icons/pj-scope-icons/enabled/');
export const baseNewImagesPath = (document.kvConfig.kioskMode || document.kvConfig.noInternetMode || location.port === '9007')
  ? './'
  : '/content/Views/visualizers/';
